import { gql } from '@apollo/client';

const UPLOAD_PDF_REPORT_MUTATION = gql`
  mutation uploadPdfReport($input: UploadPdfReportInput!) {
    uploadPdfReport(input: $input) {
      isSuccess
      message
    }
  }
`;

export default UPLOAD_PDF_REPORT_MUTATION;
